import { render, staticRenderFns } from "./Necessities.vue?vue&type=template&id=127c9db5&scoped=true"
import script from "./Necessities.vue?vue&type=script&lang=js"
export * from "./Necessities.vue?vue&type=script&lang=js"
import style0 from "./Necessities.vue?vue&type=style&index=0&id=127c9db5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c9db5",
  null
  
)

export default component.exports